export default __webpack_public_path__ + "static/media/pu_black_logo.f3655d95.svg";